import "./Skeleton.scss";

const Skeleton = ({ width = "171px", height = "112px", borderRadius = "16px" ,className}) => {
    return (
        <div className={`d-flex f-column jcc ${className}`}>
            <div
                className="skeleton"
                style={{ width, height, borderRadius }}
            />
            
        </div>
    );
}
export default Skeleton;
